import { BaseElements, BaseObject, BaseService, BaseInjector } from '../../../js/base';
import { querySelector } from '../../../utility/utils/index';
import PasswordFormatValidation from './password-format-validation';

class Texts extends BaseObject { }

class ClassList extends BaseObject {
    displayNone = 'd-none'
}

class Selectors extends BaseObject {
    form = '.change-password-form';
    modal = '.modal';
    content = '.modal-body';
    alertDanger = '.alert-danger';
    alertSuccess = '.alert-success';
}

class Elements extends BaseElements<Selectors> {
    form: HTMLElement;
    modal: HTMLElement;
    alertSuccess: HTMLElement;
    alertDanger: HTMLElement;
    constructor(selectors: Selectors) {
        super(selectors, true);
    }

    initElements() {
        this.form = querySelector(this.selectors.form);
        if (this.form) {
            this.modal = this.form.closest(this.selectors.modal);
            this.alertSuccess = querySelector(this.selectors.alertSuccess, this.modal);
            this.alertDanger = querySelector(this.selectors.alertDanger, this.modal);
        }
    }
}

interface ChangePassword extends BaseService<Selectors, Elements, ClassList, Texts> { }

@BaseInjector(Selectors, Elements, ClassList, Texts)
class ChangePassword {
    passwordFormatValidation: PasswordFormatValidation;
    initialize(): void {
        if (!this.elements.form) {
            return;
        }
        const { displayNone } = this.classList
        this.elements.form.classList.remove(displayNone);
        this.elements.alertSuccess.classList.add(displayNone);
        this.elements.alertDanger.classList.add(displayNone);
        this.elements.alertDanger.innerHTML = '';
        this.addEventListeners();
    }

    initPasswordValidation() {
        this.passwordFormatValidation = new PasswordFormatValidation();
    }

    addEventListeners(): void {
        this.elements.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onSubmit(event) {
        event.preventDefault();
        if (this.checkPasswordFormat()) {
            this.addData('submitBtn', 'submitBtn');
            const { displayNone } = this.classList
            let url = this.elements.form.getAttribute('action');
            let data = $(this.elements.form).serializeArray();

            data.push({ name: 'ajaxRequest', value: 'true' });
            $.ajax({
                context: this,
                method: 'post',
                url: url,
                data: data,
                xhrFields: { withCredentials: true }
            })
                .done(function (data, status, jqXHR) {
                    if (data.result) {
                        this.elements.form.classList.remove(displayNone);
                        this.alertSuccess.classList.add(displayNone);
                        this.alertDanger.classList.remove(displayNone);
                        this.alertDanger.innerHTML = data.message;
                    } else {
                        this.elements.form.classList.add(displayNone);
                        this.alertSuccess.classList.remove(displayNone);
                    }
                })
                .fail(function (jqXHR, status, err) {
                    this.elements.form.classList.remove(displayNone);
                    this.alertSuccess.classList.add(displayNone);
                    this.alertDanger.classList.remove(displayNone);
                    this.alertDanger.innerHTML = 'Unknown error';
                }).
                always(function () {

                });

        } else {
            this.elements.form.scrollIntoView();
        }
    }

    checkPasswordFormat() {
        return this.passwordFormatValidation.checkPasswordFormat();
    }

    //TODO: make this method shareable - move it to utils?
    addData(name: string, value: string = '') {
        let el = document.querySelector('[name="' + name + '"]');
        if (el) {
            value = el.getAttribute('value');
            el.removeAttribute('name');
        }
        let input = document.createElement('input');
        input.setAttribute('name', name);
        input.setAttribute('value', value);
        input.setAttribute('type', 'hidden');
        this.elements.form.appendChild(input);
    }

}

export default ChangePassword;

export {
    Elements as ChangePasswordElements,
    Selectors as ChangePasswordSelectors,
    ClassList as ChangePasswordClassList,
    Texts as ChangePasswordTexts
}
